"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_i18n_1 = require("vue-i18n");
var uuid_1 = require("uuid");
var global_1 = require("./global");
var policy_1 = require("./policy");
/** 應用程式 */
var Application = /** @class */ (function () {
    /**
     * 建構應用程式
     * @param name 名稱
     * @param model 領域模型
     * @param policy 策略方針
     * @param configuration 配置
     */
    function Application(component, model, policy, i18n, options) {
        var _this = this;
        this._status = global_1.ApplicationStatus.Pendding;
        options = __assign({}, options);
        this.app = options.mode === 'SSR' ? vue_1.createSSRApp(component, options) : vue_1.createApp(component, options);
        this._mode = options.mode || 'SPA';
        this.use(model);
        if (policy === null || policy === void 0 ? void 0 : policy.router)
            this.use(policy.router);
        if (i18n)
            this.use(i18n);
        this.id = uuid_1.v1();
        var customProperties = this.app.config.globalProperties;
        Object.defineProperty(customProperties, '$id', {
            get: function () { return _this.id; }
        });
        this.model = model;
        Object.defineProperty(customProperties, '$model', {
            get: function () { return _this.model; }
        });
        this.policy = policy;
        Object.defineProperty(customProperties, '$policy', {
            get: function () { return _this.policy; }
        });
        Object.defineProperty(customProperties, '$user', {
            get: function () { return _this.user; },
            set: function (value) { _this.user = value; }
        });
        Object.defineProperty(customProperties, '$menu', {
            get: function () { return _this.menu; },
            set: function (value) { _this.menu = value; }
        });
        Object.defineProperty(customProperties, '$breadcrumb', {
            get: function () { return _this.breadcrumb; }
        });
        Object.defineProperty(customProperties, '$utils', {
            get: function () { return CloudFun.utils; }
        });
        Object.defineProperty(customProperties, '$enums', {
            get: function () { return _this.enums; }
        });
        Object.defineProperty(customProperties, '$subscript', { value: function (channel, handler) {
                _this.subscript(channel, handler);
            } });
        Object.defineProperty(customProperties, '$unsubscript', { value: function (channel, handler) {
                _this.unsubscript(channel, handler);
            } });
        Object.defineProperty(customProperties, '$send', { value: function (channel, message) {
                _this.send(channel, message);
            } });
        Object.defineProperty(customProperties, '$getCertificate', { value: function (type) {
                return _this.model.getCertificate(type);
            } });
        Object.defineProperty(customProperties, '$isApproved', { value: function (permissionsOrRule) {
                var rule = permissionsOrRule instanceof policy_1.PolicyRule ? permissionsOrRule : new policy_1.PolicyRule(permissionsOrRule);
                return rule.check(_this.user.Permissions);
            } });
        Object.defineProperty(customProperties, '$makeMenu', { value: function (prefix, nodes, crumbable) {
                var _a;
                if (!((_a = _this.policy) === null || _a === void 0 ? void 0 : _a.sitemap))
                    return [];
                return _this.policy.makeMenu(nodes || _this.policy.sitemap.subNodes || [], prefix, crumbable);
            } });
        this.i18n = i18n || vue_i18n_1.createI18n({
            legacy: true,
            locale: 'zh-Hant',
            fallbackLocale: 'zh-Hant',
            messages: {
                'zh-Hant': {}
            }
        });
        this.use(this.i18n);
        Object.defineProperty(customProperties, '$locales', {
            get: function () { return _this.locales; }
        });
        Object.defineProperty(customProperties, '$locale', {
            get: function () { return _this.locale; },
            set: function (value) { _this.locale = value; }
        });
        CloudFun.push(this);
    }
    Object.defineProperty(Application.prototype, "version", {
        // #region App<Element> members
        get: function () { return this.app.version; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "config", {
        get: function () { return this.app.config; },
        enumerable: false,
        configurable: true
    });
    Application.prototype.use = function (plugin) {
        var options = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            options[_i - 1] = arguments[_i];
        }
        this.app.use(plugin, options);
        return this;
    };
    Application.prototype.mixin = function (mixin) {
        this.mixin(mixin);
        return this;
    };
    Application.prototype.mount = function (rootContainer, isHydrate) {
        return this.app.mount(rootContainer, isHydrate);
    };
    Application.prototype.unmount = function (rootContainer) {
        this.app.unmount(rootContainer);
    };
    Application.prototype.provide = function (key, value) {
        this.app.provide(key, value);
        return this;
    };
    Application.prototype.component = function (name, component) {
        if (typeof (component) === 'undefined')
            return this.app.component(name);
        this.app.component(name, component);
        return this;
    };
    Application.prototype.directive = function (name, directive) {
        if (typeof (directive) === 'undefined')
            return this.app.directive(name);
        this.app.directive(name, directive);
        return this;
    };
    Object.defineProperty(Application.prototype, "_uid", {
        get: function () { return this.app._uid; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "_component", {
        get: function () { return this.app._component; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "_props", {
        get: function () { return this.app._props; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "_container", {
        get: function () { return this.app._container; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "_context", {
        get: function () { return this.app._context; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "mode", {
        /** 模式 */
        get: function () { return this._mode; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "status", {
        /** 狀態 */
        get: function () { return this._status; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "user", {
        /** 取得用戶 */
        get: function () { return this.model.user; },
        /** 設定用戶 */
        set: function (value) { this.model.user = value; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "menu", {
        /** 取得選單 */
        get: function () { return this.model.menu; },
        /** 設定選單 */
        set: function (value) { this.model.menu = value; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "breadcrumb", {
        /** 取得麵包屑 */
        get: function () { return this.model.breadcrumb; },
        /** 設定麵包屑 */
        set: function (value) { this.model.breadcrumb = value; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "locales", {
        /** 取得可用語系 */
        get: function () { return this.i18n.global.availableLocales; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "enums", {
        /** 列舉 */
        get: function () { return this.model.enums; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "locale", {
        /** 取得目前語系 */
        get: function () { return this.i18n.global.locale; },
        /** 設定目前語系 */
        set: function (value) {
            if (this.locales.some(function (e) { return e === value; })) {
                this.i18n.global.locale = value;
                CloudFun.item(this.model.name + "-locale", value);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "componentProperties", {
        /** 取得組件屬性 */
        get: function () {
            var _a;
            return ((_a = vue_1.getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.appContext.config.globalProperties) || undefined;
        },
        enumerable: false,
        configurable: true
    });
    /** 執行 */
    Application.prototype.run = function (rootContainer, isHydreate) {
        this._status = global_1.ApplicationStatus.Running;
        this.mount(rootContainer, isHydreate);
        CloudFun.push(this);
    };
    /** 結束 */
    Application.prototype.stop = function () {
        this._status = global_1.ApplicationStatus.Stopped;
        if (this._container)
            this.unmount(this._container);
        CloudFun.remove(this);
    };
    /**
     * 開始訂閱
     * @param channel 頻道
     * @param handler 處理函式
     */
    Application.prototype.subscript = function (channel, handler) { CloudFun.subscript(channel, handler); };
    /**
     * 取消訂閱
     * @param channel 頻道
     * @param handler 處理函式
     */
    Application.prototype.unsubscript = function (channel, handler) { CloudFun.unsubscript(channel, handler); };
    /**
     * 發送訊息
     * @param channel 頻道
     * @param message 訊息
     */
    Application.prototype.send = function (channel, message) { CloudFun.send(channel, message); };
    return Application;
}());
exports.default = Application;
